export const SET_GLOBAL_NOTIFICATION = 'SET_GLOBAL_NOTIFICATION';
export const CLEAR_GLOBAL_NOTIFICATION = 'CLEAR_GLOBAL_NOTIFICATION';
export const NOTIFICATION_SUCCESS = 'NOTIFICATION_SUCCESS';
export const NOTIFICATION_ERROR = 'NOTIFICATION_ERROR';